import type { App } from 'vue';
import { env } from '@shared/config';
import { Sentry } from '@shared/sentry';

export const withSentry = (app: App) => {
  if (env.IS_SSR) {
    return;
  }

  Sentry.init({ app, initialScope: { tags: { app: 'main-page' } } });
  return Sentry;
};
